import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { GLOBAL } from "./global";

@Injectable({
  providedIn: "root"
})
export class SolicitudService {
  public url: string;
  public identity;
  public token;

  constructor(public _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  create(
    image: any,
    nombre,
    apellidos,
    email,
    re_email,
    telefono,
    licencia_funcionamiento,
    nombre_establecimiento
  ): Observable<any> {
    //let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this._http.post(
      this.url +
      "createSolicitud/" +
      nombre +
      "/" +
      apellidos +
      "/" +
      email +
      "/" +
      re_email +
      "/" +
      telefono +
      "/" +
      licencia_funcionamiento +
      "/" +
      nombre_establecimiento,
      image /*, {headers: headers}*/
    );
  }

  getSolicitudes(token): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "solicitudes", { headers: headers });
  }

  getSolicitudesRepresentantes(token): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "showPeticionesRepresentantes", {
      headers: headers
    });
  }

  getSolicitudesAtendidas(token): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "showPeticionesAtendidas", {
      headers: headers
    });
  }

  getSolicitud(token, id): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "solicitudes/" + id, { headers: headers });
  }

  getImage(token, id): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    let responseType;
    return this._http.get(this.url + "showImage/" + id, {
      headers: headers,
      responseType: "blob"
    });
  }

  getCountSolicitudes(token): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "count_solicitudes", { headers: headers });
  }

  update(token, id, solicitud): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(solicitud));
    let params = "json=" + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    // Url del back
    return this._http.put(this.url + "solicitudes/" + id, params, {
      headers: headers
    });
  }

  delete(token, info, id): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(info));
    let params = "json=" + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.put(this.url + "delete_solicitud/" + id, params, {
      headers: headers
    });
  }

  resendEmailSolicitud(token, info): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(info));
    let params = "json=" + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.post(this.url + "resendEmailSolicitud", params, { headers: headers });
  }

  createGrupo(token, grupo): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(grupo));
    let params = "json=" + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    // Url del back
    return this._http.post(this.url + "grupoEmpresas", params, {
      headers: headers
    });
  }
}
